// components/Layout.jsx
import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import './Layout.css';

const Layout = () => {
    const { admin, signOut, hasPermission } = useAuth();
    const location = useLocation();

    const handleSignOut = async () => {
        await signOut();
    };

    return (
        <div className="layout">
            {/* Верхняя панель */}
            <header className="top-bar">
                <div className="top-bar-left">
                    <h1 className="app-title">Панель управления</h1>
                </div>
                <div className="top-bar-right">
                    <div className="admin-info">
                        <span className="admin-name">{admin?.name || admin?.login}</span>
                        <span className="admin-role">{admin?.role}</span>
                    </div>
                    <button onClick={handleSignOut} className="signout-btn">
                        Выйти
                    </button>
                </div>
            </header>

            <div className="layout-content">
                {/* Боковая панель */}
                <aside className="sidebar">
                    <nav className="sidebar-nav">
                        <Link 
                            to="/dashboard" 
                            className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
                        >
                            Главная
                        </Link>
                        
                        {hasPermission('canViewProducts') && (
                            <Link 
                                to="/products" 
                                className={`nav-link ${location.pathname.startsWith('/products') ? 'active' : ''}`}
                            >
                                Товары
                            </Link>
                        )}

                        {hasPermission('canViewOrders') && (
                            <Link 
                                to="/orders" 
                                className={`nav-link ${location.pathname.startsWith('/orders') ? 'active' : ''}`}
                            >
                                Заказы
                            </Link>
                        )}
                        
                        {hasPermission('canManageAdmins') && (
                            <Link 
                                to="/admins" 
                                className={`nav-link ${location.pathname.startsWith('/admins') ? 'active' : ''}`}
                            >
                                Администраторы
                            </Link>
                        )}
                    </nav>
                </aside>

                {/* Основной контент */}
                <main className="main-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default Layout;